// apps/web/src/lib/auth-client.ts
import { magicLinkClient } from 'better-auth/client/plugins';
import { createAuthClient } from 'better-auth/react';
import { SERVER_URL } from './config';

declare global {
  interface Window {
    __STARDECIDE_AUTH_DIAGNOSTICS__?: boolean;
  }
}
const shouldRunDiagnostics = process.env.NEXT_PUBLIC_AUTH_DIAGNOSTICS !== '0';

function runClientDiagnostics() {
  if (!shouldRunDiagnostics || typeof window === 'undefined') {
    return;
  }
  if (window.__STARDECIDE_AUTH_DIAGNOSTICS__) {
    return;
  }
  window.__STARDECIDE_AUTH_DIAGNOSTICS__ = true;
  // eslint-disable-next-line no-console
  console.info('🔎 [AUTH] Client diagnostics', {
    serverUrl: SERVER_URL,
    diagnosticsEnabled: shouldRunDiagnostics,
  });
}

// This function ensures we always point to the correct backend URL.
const getBaseUrl = () => {
  // In the browser, use the public server URL directly.
  if (typeof window !== 'undefined') {
    return `${SERVER_URL}/api/auth`;
  }
  // On the server (SSR/build), also use the public server URL.
  return `${SERVER_URL}/api/auth`;
};

runClientDiagnostics();

export const authClient = createAuthClient({
  baseURL: getBaseUrl(),

  // CRITICAL: This tells the browser to send cookies with cross-domain requests.
  // This is essential for session management to work.
  fetchOptions: {
    credentials: 'include',
  },
  plugins: [magicLinkClient()],
});
